import { render, staticRenderFns } from "./csa-new.vue?vue&type=template&id=5d58c0c6&scoped=true"
import script from "./csa-new.vue?vue&type=script&lang=ts"
export * from "./csa-new.vue?vue&type=script&lang=ts"
import style0 from "./csa-new.vue?vue&type=style&index=0&id=5d58c0c6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58c0c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d58c0c6')) {
      api.createRecord('5d58c0c6', component.options)
    } else {
      api.reload('5d58c0c6', component.options)
    }
    module.hot.accept("./csa-new.vue?vue&type=template&id=5d58c0c6&scoped=true", function () {
      api.rerender('5d58c0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/csa/csa-new.vue"
export default component.exports